module.exports = __webpack_public_path__ + "img/menu-xitong.86b6771a.svg";